import { useEffect } from 'react';

declare global {
  interface Window {
    Featurebase: any;
  }
}

interface FeaturebaseMessengerProps {
  email?: string;
  userId?: string;
  createdAt?: string;
  theme?: 'light' | 'dark';
  language?: string;
}

export default function FeaturebaseMessenger({
  email,
  userId,
  createdAt,
  theme = 'light',
  language = 'en',
}: FeaturebaseMessengerProps) {
  useEffect(() => {
    // Initialize Featurebase queue if it doesn't exist
    if (typeof window.Featurebase !== 'function') {
      window.Featurebase = function (...args: any[]) {
        (window.Featurebase.q = window.Featurebase.q || []).push(args);
      };
    }

    // Boot Featurebase messenger with configuration
    // Script is preloaded in root.tsx head for faster loading
    window.Featurebase('boot', {
      appId: '69583402473c82fe9f84326c',
      ...(email && { email }),
      ...(userId && { userId }),
      ...(createdAt && { createdAt }),
      theme,
      language,
    });
  }, [email, userId, createdAt, theme, language]);

  return null;
}
